import * as tslib_1 from "tslib";
import store from '../store/store';
import { getFallbackValueIfNull } from 'owa-options-core';
import { action, select } from 'satcheljs/lib/legacy';
import { getMailboxJunkEmailConfiguration, saveMailboxJunkEmailConfiguration, } from 'owa-junkmail-configuration';
import { isEmailAddress } from 'owa-mail-option-common';
export default select({
    mailboxJunkEmailConfiguration: function () { return getMailboxJunkEmailConfiguration(); },
    optionState: function () { return store; },
})(action('saveBlockedDomainsOption')(function saveBlockedDomainsOption(state) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var _a, mailboxJunkEmailConfiguration, optionState, blockedDomains, blockedSenders, blockedSenderAndDomains;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = state, mailboxJunkEmailConfiguration = _a.mailboxJunkEmailConfiguration, optionState = _a.optionState;
                    blockedDomains = getFallbackValueIfNull(optionState.blockedDomains, mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) { return !isEmailAddress(item); }));
                    blockedSenders = mailboxJunkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
                        return isEmailAddress(item);
                    });
                    blockedSenderAndDomains = blockedSenders.concat(blockedDomains.slice());
                    mailboxJunkEmailConfiguration.BlockedSendersAndDomains = blockedSenderAndDomains;
                    return [4 /*yield*/, saveMailboxJunkEmailConfiguration(mailboxJunkEmailConfiguration)];
                case 1:
                    _b.sent();
                    return [2 /*return*/];
            }
        });
    });
}));
//# sourceMappingURL=saveBlockedDomainsOption.js.map